// Matches the Meta-Information devices string
export const deviceFilterRegex = /^(?<manufacturer>-|\*|\w+)(\/(?<model>\*|\w+))?(;(?<valueTypes>\w+(,\w+)?))?$/i;
